// extracted by mini-css-extract-plugin
export default {"Clients":"Clients_Clients__d0oKT","ClientsList":"Clients_ClientsList__ICdAG","ClientsHeader":"Clients_ClientsHeader__zh5Fv"};